import z from 'zod'
import type { AddressResponse } from '~/types/global'

export const integrationFormSchema = z.object({
  email: z.preprocess(
    (value) =>
      typeof value === 'string' && value !== '' ? value.trim() : null,
    z.email('Email invalide').nullable()
  ),
  firstname: z.string().default(''),
  lastname: z.string().default(''),
  phone: z.string().default(''),
  address: z.custom<Omit<AddressResponse, 'id'>>().nullable().optional(),
  qualifications: z.array(z.string()).default([]),
  segmentations: z.array(z.string()).default([])
})

export type IntegrationFormValues = z.infer<typeof integrationFormSchema>
